import { render, staticRenderFns } from "./IssueList.vue?vue&type=template&id=ee4ddc70&scoped=true&"
import script from "./IssueList.vue?vue&type=script&lang=js&"
export * from "./IssueList.vue?vue&type=script&lang=js&"
import style0 from "./IssueList.vue?vue&type=style&index=0&id=ee4ddc70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4ddc70",
  null
  
)

export default component.exports